import Store from '~/store'
import { steps as signupSteps } from '../mixins/SignupPageMixin'

export default {
    shouldShowSignupStep(step) {
        if (signupSteps.find((value) => value === step)) {
            return Store.getters['ui/getShowSignupSteps'][step]
        }
        return false
    },

    showSignupStep(step) {
        Store.dispatch('ui/showSignupStepPage', { step: step, flag: true })
    },

    hideSignupStep(step) {
        Store.dispatch('ui/showSignupStepPage', { step: step, flag: false })
    },

    resetAllShowSignupSteps() {
        signupSteps.forEach((step) => Store.dispatch('ui/showSignupStepPage', { step: step, flag: false }))
    },
}
